const Lightbox = {

	elements: {},

	openLightbox(src, type='iframe', mainClass='')
	{
		const self = this;
		let settings = {
			'items': {
				'src': src,
                'type': type,
                'iframe': {
                    'markup': '<div class="mfp-iframe-scaler">' +
                            '   <div class="mfp-close"></div>' +
                            '   <iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
                            '</div>'
                }
            },
            'mainClass': mainClass,
			'closeOnBgClick': false,
			'enableEscapeKey': true,
			'alignTop': false,
			'callbacks': {
				'open': function() {
					window.dispatchEvent( new CustomEvent('onLightboxOpen'));
                    document.body.classList.add('lightbox-open');
				},

				close: function() {
					window.dispatchEvent( new CustomEvent('onLightboxClose'));
					document.body.classList.remove('lightbox-open');
				}
			}
        };

		$.magnificPopup.open(settings);
	},

	cacheDom()
	{
		this.elements.lightboxLinks = document.querySelectorAll('.js-lightbox');
	},

	bind()
	{
		if( this.elements.lightboxLinks )
		{
			Array.prototype.forEach.call(this.elements.lightboxLinks, (element) => {
                const src = element.getAttribute('href');
                const type = element.getAttribute('data-type') || 'iframe';
                const mainClass = element.getAttribute('data-lightbox-classname') || '';

                element.addEventListener('click', (e) => {
					e.preventDefault();
					this.openLightbox(src, type, mainClass);
				});
			});
		}
	},

	init()
	{
		this.cacheDom();
		this.bind();
	}
};

export default Lightbox;